module.exports = __webpack_public_path__ + "static/media/diamonds.9f53442d.svg";